export default "__VITE_ASSET__DWURdDeR__"